import { CircularProgress } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import { STRINGS } from "../../config/strings";
import { useProviderSearchStore } from "../../store/providerSearchStore";

import MapControls from "./MapControls";
import MapView from "./MapView";
import SearchOverlay from "./SearchOverlay";

export default function CustomMap({
  data,
  children,
  loading,
  radius = STRINGS.DEFAULT_MAP_RADIUS,
  sourceLatitude,
  sourceLongitude,
  selectedCenter,
  markerData
}) {
  const store = useProviderSearchStore();
  const ref = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const center = { lat: Number(sourceLatitude), lng: Number(sourceLongitude) };

  useEffect(() => {
    const handle = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handle);
    return () => document.removeEventListener("fullscreenchange", handle);
  }, []);

  const toggleFullscreen = () =>
    document.fullscreenElement ? document.exitFullscreen() : ref.current?.requestFullscreen();

  if (loading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <CircularProgress style={{ color: HNSColors.secondary[500] }} />
      </div>
    );
  }
  return (
    <div ref={ref} className="relative h-full w-full">
      {store.showMap && (
        <MapView data={data} center={center} radius={radius} zoom={store.zoom} selectedCenter={selectedCenter} markerData={markerData}>
          {children}
        </MapView>
      )}
      {store.showCustomSearch && !store.isProviderMapPage && <SearchOverlay />}
      {store.showMap && (
        <MapControls
          isFullscreen={isFullscreen}
          toggleFullscreen={toggleFullscreen}
          showMap={store.showMap}
          setShowMap={store.setShowMap}
        />
      )}
    </div>
  );
}
